import axios from 'axios';

import * as mappers from './serviceMappers';

export function fetchConsoleCommandLogList(params) {
  return axios
    .get('console-command-logs/', { params: mappers.mapFetchConsoleCommandLogListRequest(params) })
    .then((response) => mappers.mapFetchConsoleCommandLogListResponse(response.data));
}
